export default "__VITE_ASSET__uQ6FLMOi__"